import type { ReactNode } from 'react';

export const symbol_taunt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M204-418q-21 11-44 5.5T126-439q-13-25-4.5-52t35.5-36l313-106q11-4 21.43 1.17t17.39 18.69q6.18 11.14 2 23.06Q506.64-578.15 496-572L204-418Zm106 298q-24.75 0-42.37-17.63Q250-155.25 250-180v-194l317.87-167.91Q582-550 587.5-565.5 593-581 585-595l193-96q11-5 22.95-.05 11.95 4.94 19.65 20.16Q826-661 823.5-651q-2.5 10-11.5 17L550-438v258q0 24.75-17.62 42.37Q514.75-120 490-120H310ZM208-618.1q-38-38.1-38-92t38.1-91.9q38.1-38 92-38t91.9 38.1q38 38.1 38 92T391.9-618q-38.1 38-92 38T208-618.1Z"
		/>
	</svg>
);
